import { render, staticRenderFns } from "./GrafoV2.vue?vue&type=template&id=4b5038aa&"
import script from "./GrafoV2.vue?vue&type=script&lang=js&"
export * from "./GrafoV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports